import { createNotesContextProvider } from 'src/SharedCommonContext/GenericNotesContextFactory';

export const {
  NotesProvider: ItemNotesProvider,
  useNotesDataFromContext: useItemNotesDataFromContext,
  useNotesActionsFromContext: useItemNotesActionsFromContext,
} = createNotesContextProvider({
  itemType: 'Item',
  displayName: 'item',
});
